import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';
import { forkJoin } from 'rxjs/observable/forkJoin';

import { Account, LoginModalService, Principal } from '../shared';
import { Student, StudentService } from '../entities/student';
import { CardTypeService, CardType } from '../entities/card-type';
import { SchoolCalendarService, SchoolCalendar } from '../entities/school-calendar';
import { CardService, Card, CardStats } from '../entities/card';
import { TranslateService } from 'ng2-translate';
import { HttpResponse } from '@angular/common/http';

enum TimePeriod {
    TODAY = 0,
    PERIOD = 1
};

@Component({
    selector: 'jyogui-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: [
        'dashboard.scss'
    ]
})
export class DashboardComponent implements OnInit {
    account: Account;
    modalRef: NgbModalRef;
    student: Student;
    schoolCalendars: SchoolCalendar[];
    selectedSchoolCalendar: SchoolCalendar;
    today: any;
    cardTypes: CardType[];
    cardCountByType: any[];
    cardTotalExpectedByType: any[];
    cardTotalCollectedByType: any[];
    totalCount: number;
    totalExpected: number;
    totalCollected: number;
    view: any[] = [700, 500];
    xCountAxis: string ;
    yCountAxis: string;
    xExpectedAxis: string;
    yExpectedAxis: string;
    xCollectedAxis: string;
    yCollectedAxis: string;
    isLoading: boolean = false;

    colorSchemeCards = {
        domain: ['#596323', '#C8C234', '#BFAA34',
                 '#8F5238', '#532D32', '#9a8e8a',
                 '#1d4163', '#546918', '#d69c1e', '#61251d']
    };

    private baseQuery: string;

    constructor(
        private alertService: AlertService,
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private loginModalService: LoginModalService,
        private cardTypeService: CardTypeService,
        private cardService: CardService,
        private eventManager: EventManager,
        private schoolCalendarService: SchoolCalendarService,
        private studentService: StudentService,
        private translateService: TranslateService,
        private languageService: JhiLanguageService
    ) {
        this.jhiLanguageService.setLocations(['dashboard']);
    }

    ngOnInit() {
        this.today = new Date();
        this.principal.identity().then((account) => {
            this.account = account;

            this.loadCurrentStudent()
            .add(() => {
                this.loadSchoolCalendar()
                .add(() => {
                    // Search for the card types
                    this.loadTypesOfCard()
                    .add(() => {
                        this.loadLabels();
                        // Once retrieved the card types, look up for the cards
                        this.loadStats();
                    });
                });
            });
        });
    }

    public selectedSchoolCalendarChanged($event) {
        this.loadLabels();
        this.loadStats();
    }

    private loadLabels() {
        this.xCountAxis = this.translateService.instant('jYoguiApp.dashboard.xCountAxis');
        this.yCountAxis = this.translateService.instant('jYoguiApp.dashboard.yCountAxis');
        this.xExpectedAxis = this.translateService.instant('jYoguiApp.dashboard.xExpectedAxis');
        this.yExpectedAxis = this.translateService.instant('jYoguiApp.dashboard.yExpectedAxis');
        this.xCollectedAxis = this.translateService.instant('jYoguiApp.dashboard.xCollectedAxis');
        this.yCollectedAxis = this.translateService.instant('jYoguiApp.dashboard.yCollectedAxis');
    }

    private loadCurrentStudent() {
        return this.studentService.getCurrent()
            .subscribe((student: Student) => {
                this.student = student;
                this.baseQuery = `school.id:${this.student.schoolId}`;
            });
    }

    private loadSchoolCalendar() {
        const datePipe = new DatePipe(this.languageService.currentLang);
        const today = datePipe.transform(this.today, 'yyyy-MM-dd');
        const query = `school.id:${this.student.schoolId}`;

        return this.schoolCalendarService.search({
            query: query,
            sort: ['begining,desc']
        })
        .subscribe((res: HttpResponse<SchoolCalendar[]>) => {
            this.schoolCalendars = res.body;
            // Take the last one
            this.selectedSchoolCalendar = this.schoolCalendars[0];
        });
    }

    private loadTypesOfCard() {
        return this.cardTypeService.search({
            query: this.baseQuery,
            sort: []
        })
        .subscribe((res: HttpResponse<CardType[]>) => {
            this.cardTypes = res.body;
            return res.body;
        });
    }

    private loadStats(typeName?: string) {
        this.isLoading = true;
        this.cardCountByType = [];
        this.cardTotalExpectedByType = [];
        this.cardTotalCollectedByType = [];
        this.totalCount = 0;
        this.totalExpected = 0;
        this.totalCollected = 0;

        const datePipe = new DatePipe(this.languageService.currentLang);
        const today = datePipe.transform(this.today, 'yyyy-MM-dd');
        const beginning = datePipe.transform(this.selectedSchoolCalendar.begining, 'yyyy-MM-dd');
        const ending = datePipe.transform(this.selectedSchoolCalendar.ending, 'yyyy-MM-dd');

        let query = this.baseQuery + ` AND validUntil:[${beginning} TO ${ending}]`;
        const requests = [];
        _.each(this.cardTypes, (cardType) => {
            const queryByType = `${query} AND cardType.id:${cardType.id}`;
            requests.push(this.cardService.searchStats({ query: queryByType, sort: [] }));
        });

        forkJoin(requests)
        .subscribe((response: HttpResponse<any>[]) => {
            response.forEach(responseItem => {
                let stats: CardStats[] = responseItem.body;

                if (stats.length > 0) {
                    this.cardCountByType.push({
                        'name': stats[0].label,
                        'value': stats[0].count
                    });
                    this.totalCount += stats[0].count;

                    this.cardTotalExpectedByType.push({
                        'name': stats[0].label,
                        'value': stats[0].totalExpected
                    });
                    this.totalExpected += stats[0].totalExpected;

                    this.cardTotalCollectedByType.push({
                        'name': stats[0].label,
                        'value': stats[0].totalCollected
                    });
                    this.totalCollected += stats[0].totalCollected;

                }
            });
            this.isLoading = false;
        });
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/dashboard/dashboard.component.ts